import { useEffect, useState } from 'react';
// import axios from '@/services/axiosInstance';
import axiosInstance from "../helpers/Axios";

const HomeAffiche = () => {
  const [src, setSrc] = useState<string | null>(null);

  useEffect(() => {
    const loadAffiche = async () => {
      const res = await axiosInstance.get('/image');

      const folder = res.data.find(
        (f: any) => f.name === 'affiche'
      );

      if (!folder?.files || folder.files.length === 0) return;

      // ✅ on prend la première (ou triée)
      const file = folder.files.sort()[0];

      setSrc(
        `${import.meta.env.VITE_BACKEND_URL}/images/affiche/${file}`
      );
    };

    loadAffiche();
  }, []);

  if (!src) return null;

  return (
    <div className="home-affiche">
      <img
        src={src}
        alt="Affiche"
        loading="lazy"
      />
    </div>
  );
};

export default HomeAffiche;
